import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {
  Command,
  CommandStore,
  ScannerStore,
  showRequestErrors,
  SOFTLINE_FEATURE_COMMANDS,
  SOFTLINE_FEATURE_SCANNER,
  SOFTLINE_FEATURE_TITLE,
  TitleStore
} from '@softline/application';
import {RequestError, Store} from '@softline/core';
import {MessageBarStore, SOFTLINE_FEATURE_MESSAGE_BAR} from '@softline/ui-core';
import {Router, RouterModule} from '@angular/router';

@Component({
    selector: 'lib-product-scan',
    imports: [RouterModule],
    templateUrl: './product-scan.component.html',
    styleUrls: ['./product-scan.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductScanComponent implements OnInit, OnDestroy {

  constructor(private store: Store, protected router: Router) { }

  async ngOnInit(): Promise<void> {
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '#PRODUCT_SCAN.TITLE');
    this.store.commit(SOFTLINE_FEATURE_COMMANDS, CommandStore.mutations.addSet, {
      name: ProductScanComponent,
      commands: this.createCommands()
    });
  }

  ngOnDestroy(): void {
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '');
    this.store.commit(SOFTLINE_FEATURE_COMMANDS, CommandStore.mutations.removeSet, ProductScanComponent);
  }

  protected createCommands(): Command[] {
    return [
      {
        icon: 'fa-regular fa-magnifying-glass',
        name: '#PRODUCT_SCAN.TITLE',
        class: 'menu main-menu main-menu-top',
        routerLink: ['artikelinfo']
      },
      {
        name: 'Scan',
        icon: 'fa-regular fa-barcode-scan',
        class: 'menu top-menu top-menu-right',
        execute: async  () => {
          try {
            await this.store.dispatch(SOFTLINE_FEATURE_SCANNER, ScannerStore.actions.scan, {labelType: ['ean13', 'ean8', 'itf', 'ean128', 'qrcode']});
          } catch (e: any) {
            if (e instanceof RequestError) {
              await this.store.dispatch(SOFTLINE_FEATURE_MESSAGE_BAR, MessageBarStore.actions.error, {
                title: '#MESSAGES.ERROR.TITLE',
                message: '#MESSAGES.ERROR.SCAN_ERROR'
              });
            } else {
              showRequestErrors(this.store, e);
            }
          }
        }
      }
    ];
  }
}
